import { jsx as _jsx } from "react/jsx-runtime";
import { ToolOutlined } from "@ant-design/icons";
import { Result } from "antd";
const UsersPage = () => {
    return (_jsx(Result, { icon: _jsx(ToolOutlined, {}), title: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438", subTitle: "\u0420\u0430\u0437\u0434\u0435\u043B \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435" }));
};
export default UsersPage;
